"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Typography = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _classnames = _interopRequireDefault(require("classnames"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Typography = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Typography, _Component);

  var _super = _createSuper(Typography);

  function Typography() {
    var _this;

    (0, _classCallCheck2.default)(this, Typography);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          align = _this$props.align,
          children = _this$props.children,
          color = _this$props.color,
          component = _this$props.component,
          gutterBottom = _this$props.gutterBottom,
          noWrap = _this$props.noWrap,
          paragraph = _this$props.paragraph,
          variant = _this$props.variant,
          onClick = _this$props.onClick,
          className = _this$props.className,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["align", "children", "color", "component", "gutterBottom", "noWrap", "paragraph", "variant", "onClick", "className"]);
      return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({
        className: (0, _classnames.default)(className, "prmbl-typography"),
        onClick: onClick,
        align: align,
        color: color,
        component: component,
        gutterBottom: gutterBottom,
        noWrap: noWrap,
        paragraph: paragraph,
        variant: variant
      }, otherProps), children);
    });
    return _this;
  }

  return Typography;
}(_react.Component);

exports.Typography = Typography;
(0, _defineProperty2.default)(Typography, "propTypes", {
  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Set the text-align on the component.
   */
  align: _propTypes.default.oneOf(["inherit", "left", "center", "right", "justify"]),

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: _propTypes.default.oneOf(["inherit", "primary", "textSecondary", "secondary", "error", "initial"]),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func, _propTypes.default.object]),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: _propTypes.default.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with an ellipsis.
   */
  noWrap: _propTypes.default.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: _propTypes.default.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: _propTypes.default.oneOf(["h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "caption", "button"]),

  /**
   * Controls the display type
   */
  display: _propTypes.default.oneOf(["initial", "block", "inline"]),

  /**
   * @ignore
   */
  onClick: _propTypes.default.func
});
(0, _defineProperty2.default)(Typography, "defaultProps", {
  align: "inherit",
  color: "initial",
  gutterBottom: false,
  noWrap: false,
  paragraph: false,
  variant: "body1",
  display: "initial"
});
var _default = Typography;
exports.default = _default;